<!-- eslint-disable max-len -->
<template>
<svg
    width="48" height="48" viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_459_24090)">
        <path opacity="0.2" d="M13.8906 9.46094C12.3014 12.8375 11.0017 16.343 10.0056 19.9395C9.76893 20.8105 9.7065 21.7197 9.82194 22.6148C9.93737 23.51 10.2284 24.3736 10.6783 25.156C11.1283 25.9385 11.7282 26.6244 12.4438 27.1745C13.1595 27.7245 13.9766 28.1279 14.8485 28.3615C15.7203 28.595 16.6297 28.6541 17.5244 28.5354C18.4192 28.4168 19.2817 28.1226 20.0625 27.6698C20.8433 27.2171 21.5271 26.6146 22.0745 25.897C22.622 25.1794 23.0224 24.3608 23.2528 23.4881C24.1241 19.7871 24.6973 16.0221 24.9671 12.2295L13.8906 9.46094Z" fill="#F3F3FD" />
        <path opacity="0.2" d="M36.3328 14.2148C38.0034 17.7102 39.3657 21.3447 40.4043 25.077C40.641 25.948 40.7034 26.8571 40.588 27.7523C40.4725 28.6475 40.1815 29.5111 39.7316 30.2935C39.2816 31.076 38.6817 31.7619 37.9661 32.312C37.2504 32.862 36.4333 33.2654 35.5614 33.4989C34.6896 33.7325 33.7802 33.7916 32.8855 33.6729C31.9907 33.5542 31.1282 33.2601 30.3474 32.8073C29.5666 32.3545 28.8828 31.7521 28.3354 31.0345C27.7879 30.3169 27.3875 29.4982 27.1571 28.6256C26.0857 24.6141 25.5585 20.4827 25.3164 16.9706L36.3328 14.2148Z" fill="#F3F3FD" />
        <path
            d="M25.2047 7.99944L32.0619 6.28516C32.0619 6.28516 37.7362 15.1459 40.3976 25.0802C40.6343 25.9512 40.6967 26.8603 40.5813 27.7555C40.4659 28.6507 40.1748 29.5142 39.7249 30.2967C39.275 31.0791 38.675 31.7651 37.9594 32.3151C37.2438 32.8652 36.4266 33.2686 35.5548 33.5021C34.6829 33.7357 33.7735 33.7948 32.8788 33.6761C31.984 33.5574 31.1215 33.2632 30.3407 32.8105C29.5599 32.3577 28.8761 31.7552 28.3287 31.0376C27.7812 30.32 27.3808 29.5014 27.1504 28.6287C24.489 18.6944 25.2047 7.99944 25.2047 7.99944Z" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M35.5469 33.4785L38.624 44.9578" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M44.0631 43.5039L33.7773 46.2596" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M25.1985 2.85686L18.3414 1.14258C18.3414 1.14258 12.6671 10.0033 10.0056 19.9376C9.76893 20.8086 9.7065 21.7177 9.82194 22.6129C9.93737 23.5081 10.2284 24.3717 10.6783 25.1541C11.1283 25.9366 11.7282 26.6225 12.4438 27.1726C13.1595 27.7226 13.9766 28.126 14.8485 28.3595C15.7203 28.5931 16.6297 28.6522 17.5245 28.5335C18.4192 28.4148 19.2817 28.1207 20.0625 27.6679C20.8433 27.2151 21.5271 26.6127 22.0745 25.8951C22.622 25.1775 23.0224 24.3588 23.2528 23.4862C25.6892 13.5283 25.1985 2.85686 25.1985 2.85686Z" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M14.8584 28.3359L11.7812 39.8152" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M6.34375 38.3594L16.6295 41.1151" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M25.3047 16.9748L36.3297 14.2148" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M24.9671 12.2295L13.8906 9.46094" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M38.9219 4.57171L42.3504 2.85742" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M42.3438 11.4297H45.7723" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M9.77232 2.85686L6.34375 1.14258" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
        <path
            d="M6.35045 9.71484H2.92188" stroke="#F3F3FD" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
        />
    </g>
    <defs>
        <clipPath id="clip0_459_24090">
            <rect width="48" height="48" fill="white" />
        </clipPath>
    </defs>
</svg>
</template>
